var _templateObject, _templateObject2;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled from 'styled-components';
var StyledHeading = styled.header(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var heading = _ref.theme.yoga.components.heading;
  return "\n    background: " + heading.background + ";\n    padding: " + heading.padding.vertical + "px " + heading.padding.horizontalMobile + "px;\n    width: 100%;\n    min-height: " + heading.height + "px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    @media(min-width: 769px) {\n        padding: " + heading.padding.vertical + "px " + heading.padding.horizontal + "px;\n    }\n  ";
});
export var Button = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref2) {
  var heading = _ref2.theme.yoga.components.heading;
  return "\n    width: " + heading.button.width + "px;\n    height: " + heading.button.height + "px;\n  ";
});
export default StyledHeading;